/** 
 * All E-Bikes */
$(".alleShow").click(function(){
    $(".ebikesuv").parent().fadeIn();
    $(".ebikecity").parent().fadeIn();
    $(".ebikecompact").parent().fadeIn();
    $(".ebikeurban").parent().fadeIn();
    $(".ebikelite").parent().fadeIn();
});
$(".suvShow").click(function(){
    $(".ebikesuv").parent().fadeIn();
    $(".ebikecity").parent().fadeOut();
    $(".ebikecompact").parent().fadeOut();
    $(".ebikeurban").parent().fadeOut();
    $(".ebikelite").parent().fadeOut();
});
$(".cityShow").click(function(){
    $(".ebikesuv").parent().fadeOut();
    $(".ebikecity").parent().fadeIn();
    $(".ebikecompact").parent().fadeOut();
    $(".ebikeurban").parent().fadeOut();
    $(".ebikelite").parent().fadeOut();
});
$(".compactShow").click(function(){
    $(".ebikesuv").parent().fadeOut();
    $(".ebikecity").parent().fadeOut();
    $(".ebikecompact").parent().fadeIn();
    $(".ebikeurban").parent().fadeOut();
    $(".ebikelite").parent().fadeOut();
});
$(".urbanShow").click(function(){
    $(".ebikesuv").parent().fadeOut();
    $(".ebikecity").parent().fadeOut();
    $(".ebikecompact").parent().fadeOut();
    $(".ebikeurban").parent().fadeIn();
    $(".ebikelite").parent().fadeOut();
});
$(".liteShow").click(function(){
    $(".ebikesuv").parent().fadeOut();
    $(".ebikecity").parent().fadeOut();
    $(".ebikecompact").parent().fadeOut();
    $(".ebikeurban").parent().fadeOut();
    $(".ebikelite").parent().fadeIn();
});

/**
 *Product Specs  */
$(".allgemeinShow").click(function(){
    $(".Allgemein").slideDown();
    $(".Cockpit").slideUp();
    $(".LRA").slideUp();
});
$(".cockpitShow").click(function(){
    $(".Allgemein").slideUp();
    $(".Cockpit").slideDown();
    $(".LRA").slideUp();
});
$(".lraShow").click(function(){
    $(".Allgemein").slideUp();
    $(".Cockpit").slideUp();
    $(".LRA").slideDown();
});


$(document).ready(function() {
    $('.thumbnail-item').on('click', function() {
        var currentIndex = $(this).index();
        
        var bigImageUrls = [
            'https://cdn.shopify.com/s/files/1/0803/6545/3528/files/thumbnail-modal1.png?v=1772184119',
            'https://cdn.shopify.com/s/files/1/0803/6545/3528/files/thumbnail-modal2.png?v=1772184119',
            'https://cdn.shopify.com/s/files/1/0803/6545/3528/files/thumbnail-modal3.png?v=1772184119',
            'https://cdn.shopify.com/s/files/1/0803/6545/3528/files/thumbnail-modal4.png?v=1772184119',
            'https://cdn.shopify.com/s/files/1/0803/6545/3528/files/thumbnail-modal5.png?v=1772184119'

        ];
        var targetBigImageUrl = bigImageUrls[currentIndex];

        $('#big-image').attr('src', targetBigImageUrl);
        $(this).addClass('active').siblings().removeClass('active');
    });
});


var swiperText = new Swiper(".toggleText", {
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }
});
var swiperImage = new Swiper(".rotateImg", {
    effect: "cards",
    grabCursor: true,
    loop: true,
    controller: {
        control: swiperText
    }
});
swiperText.controller.control = swiperImage;



 $(document).ready(function() {
    // 定义元素选择器
    const $openBtn = $('.newsletter-popup');
    const $overlay = $('.modal-overlay');
    const $modalBox = $('.modal-box');
    const $closeBtn = $('.close-btn');

    // 点击按钮打开弹出层
    $openBtn.click(function() {
        $overlay.fadeIn(300); // 遮罩层淡入
        $modalBox.fadeIn(300); // 弹出层淡入
                
        // 可选：重新加载iframe（避免缓存）
        // $('.modal-iframe').attr('src', $('.modal-iframe').attr('src'));
    });

    // 点击关闭按钮关闭弹出层
    $closeBtn.click(closeModal);

    // 点击遮罩层关闭弹出层
    $overlay.click(closeModal);

    // 按ESC键关闭弹出层
    $(document).keydown(function(e) {
        if (e.keyCode === 27 && $modalBox.is(':visible')) {
            closeModal();
        }
    });

    // 关闭弹出层的通用函数
    function closeModal() {
        $overlay.fadeOut(300); // 遮罩层淡出
        $modalBox.fadeOut(300); // 弹出层淡出
    }
});